import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const StatisticsSection = ({ statistics }) => {
  const [selectedPeriod, setSelectedPeriod] = useState('7d');

  const periods = [
    { value: '7d', label: '7 days' },
    { value: '30d', label: '30 days' },
    { value: '90d', label: '90 days' }
  ];

  const getStatForPeriod = (statKey) => {
    return statistics?.[selectedPeriod]?.[statKey] || 0;
  };

  const statItems = [
    {
      key: 'profileViews',
      label: 'Profile Views',
      icon: 'Eye',
      color: 'primary'
    },
    {
      key: 'searchAppearances',
      label: 'Search Appearances',
      icon: 'Search',
      color: 'accent'
    },
    {
      key: 'employerInterest',
      label: 'Employer Interest',
      icon: 'Heart',
      color: 'destructive'
    },
    {
      key: 'profileUnlocks',
      label: 'Profile Unlocks',
      icon: 'Unlock',
      color: 'success'
    }
  ];

  return (
    <div className="bg-card rounded-xl shadow-elevation border border-border">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-foreground">Performance Analytics</h3>
          <div className="flex items-center space-x-2">
            {periods?.map((period) => (
              <button
                key={period?.value}
                onClick={() => setSelectedPeriod(period?.value)}
                className={`px-3 py-1 text-sm rounded-md transition-colors ${
                  selectedPeriod === period?.value
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                }`}
              >
                {period?.label}
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="p-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
          {statItems?.map((item) => (
            <div key={item?.key} className="text-center">
              <div className={`h-12 w-12 rounded-lg bg-${item?.color}/10 flex items-center justify-center mx-auto mb-2`}>
                <Icon name={item?.icon} size={24} className={`text-${item?.color}`} />
              </div>
              <div className="text-2xl font-bold text-foreground">
                {getStatForPeriod(item?.key)}
              </div>
              <div className="text-sm text-muted-foreground">{item?.label}</div>
            </div>
          ))}
        </div>

        <div className="space-y-4">
          <div>
            <h4 className="text-sm font-medium text-foreground mb-2">Top Skills Searched</h4>
            <div className="space-y-2">
              {statistics?.topSkills?.map((skill, index) => (
                <div key={index} className="flex items-center justify-between">
                  <span className="text-sm text-muted-foreground">{skill?.name}</span>
                  <div className="flex items-center space-x-2">
                    <div className="w-20 h-2 bg-muted rounded-full">
                      <div 
                        className="h-2 bg-primary rounded-full"
                        style={{ width: `${skill?.percentage}%` }}
                      />
                    </div>
                    <span className="text-sm font-medium text-foreground w-8">
                      {skill?.percentage}%
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-foreground mb-2">Industry Interest</h4>
            <div className="flex flex-wrap gap-2">
              {statistics?.industryInterest?.map((industry, index) => (
                <span 
                  key={index}
                  className="px-3 py-1 bg-accent/10 text-accent text-sm rounded-full"
                >
                  {industry?.name} ({industry?.count})
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatisticsSection;